import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { Card } from 'react-bootstrap';
import config from '../../../../config';
import ReportTable from './ReportTable';

const appendParam = (params, key, value) => {
  if (value !== null && value !== undefined && value !== '') {
    params.append(key, value);
  }
};

export default function LiquidacaoTab({ identificador, filtros, onReportChange }) {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isValid = true;

    async function fetchReport() {
      if (!identificador) return;

      setLoading(true);
      setReport(null);

      try {
        const params = new URLSearchParams();
        appendParam(params, 'unidadeJurisdicionada', filtros.unidadeJurisdicionada);
        appendParam(params, 'exercicio', filtros.exercicio);
        appendParam(params, 'tipoId', filtros.tipoId);
        appendParam(params, 'modalidadeExecucaoId', filtros.modalidadeExecucaoId);
        appendParam(params, 'numero', filtros.numero);
        appendParam(params, 'autoria', filtros.autoria);
        appendParam(params, 'objeto', filtros.objeto);
        appendParam(params, 'situacaoId', filtros.situacaoId);

        let url = `${config.api_path}/public/v1/transparencia/emenda-parlamentar-liquidacao/${identificador}`;
        if (params.toString()) url += `?${params.toString()}`;

        const res = await Axios.get(url);

        if (isValid && !res.data.error) {
          const reportData = res.data.data;
          setReport(reportData);
          if (onReportChange) onReportChange(reportData);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (isValid) setLoading(false);
      }
    }

    fetchReport();

    return () => {
      isValid = false;
    };
  }, [identificador, filtros]);

  if (!identificador) {
    return (
      <Card className='my-2'>
        <Card.Body className='text-muted'>Identificador do portal não informado.</Card.Body>
      </Card>
    );
  }

  return <ReportTable report={report} loading={loading} />;
}
